import { render, staticRenderFns } from "./header.vue?vue&type=template&id=75767904&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=75767904&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=75767904&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75767904",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75767904')) {
      api.createRecord('75767904', component.options)
    } else {
      api.reload('75767904', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=75767904&scoped=true", function () {
      api.rerender('75767904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/static/header/header.vue"
export default component.exports